module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"lodash","commonjs2":"lodash","amd":"lodash","root":"_"}
// module id = 3
// module chunks = 0